// app/javascript/controllers/mobile_menu_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["menu"]

    connect() {
        this.boundHandleClickOutside = this.handleClickOutside.bind(this);
        this.boundHandleKeydown = this.handleKeydown.bind(this);

        // Close menu when clicking outside
        document.addEventListener('click', this.boundHandleClickOutside);

        // Close menu when pressing escape key
        document.addEventListener('keydown', this.boundHandleKeydown);
    }

    disconnect() {
        document.removeEventListener('click', this.boundHandleClickOutside);
        document.removeEventListener('keydown', this.boundHandleKeydown);
    }

    toggle() {
        this.menuTarget.classList.toggle('hidden')
        document.body.classList.toggle('overflow-hidden')
    }

    close() {
        this.menuTarget.classList.add('hidden')
        document.body.classList.remove('overflow-hidden')
    }

    handleClickOutside(event) {
        if (!this.menuTarget.classList.contains('hidden') &&
            !this.element.contains(event.target)) {
            this.close()
        }
    }

    handleKeydown(event) {
        if (event.key === 'Escape') {
            this.close()
        }
    }
}
